export default __webpack_public_path__ + "static/media/pay_retail.e0c86084.png";